"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _common = require("../@api/common");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GlobalLoader = function GlobalLoader(_ref) {
  var app = _ref.app,
    spin = _ref.spin,
    content = _ref.content,
    instant = _ref.instant;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "central-full-logo ".concat(spin ? 'spinning' : 'not-spinning', " ").concat(instant ? 'instant' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "app-logo"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: (0, _common.getAppImageSrc)(app, 'dark')
  })), spin && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loading icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faCircleNotch"
  })), !!content ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-container"
  }, content) : '');
};
var _default = GlobalLoader;
exports["default"] = _default;